(() => {
	angular
		.module('main')
		.controller('IntegrationsController', IntegrationsController);

	IntegrationsController.$inject = [
		'$scope',
		'$rootScope',
		'$routeParams',
		'$location',
		'integrationsDataService',
		'messageService',
		'settingsService',
		'shootProofDataService'
	];

	function IntegrationsController(
		$scope,
		$rootScope,
		$routeParams,
		$location,
		integrationsDataService,
		messageService,
		settingsService,
		shootProofDataService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$rootScope.accountsList = {};
			$rootScope.accountsQB = {};

			$scope.isXeroSpinningWheelActive = false;
			$scope.isXeroDisconnectSpinningWheelActive = false;
			$scope.isShootProofSpinningWheelActive = false;
			$scope.isQbSpinningWheelActive = false;
			$scope.isFundySpinningWheelActive = false;
			$scope.isFundyDisconnectSpinningWheelActive = false;
			$scope.connectedToFundy = false;
			$scope.fundyAvailable = false;

			getIntegrationStatus();

			settingsService.timeFormatSettings.subscribe(data => {
				if (data.fundyAvailable) {
					$scope.fundyAvailable = true;
					if (data.fundyIntegration === 'ENABLED') {
						$scope.connectedToFundy = true;
					}
				}
			});

			const token = $routeParams.xero;

			if (token) {
				if ($rootScope.activeToken !== token) {
					$rootScope.activeToken = token;

					handleReceivedToken(token);
				}
			} else {
				$rootScope.activeToken = '';
			}
		});

		$scope.roundedIntegration = function() {};

		function handleReceivedToken(token) {
			const params = $location.search();

			$scope.lockIntegrationButtons = true;

			if (token === 'xero') {
				toastr.info(
					'It may take a few minutes',
					"Hold your horses! We're loading your Xero integration settings."
				);
				handleXeroToken(params);
			} else if (token === 'qb') {
				messageService.showToaster('i_0', 'qb');
				handleQuickbooksToken(params);
			} else if (token === 'shootproof') {
				handleShootproofToken(params);
			} else if (
				token.errorMessage.includes(
					'QuickBooks companies are not supported yet'
				)
			) {
				messageService.showToaster('e_8', 'qb');
			} else {
				console.error('Unknown token');
			}
		}

		function handleXeroToken(params) {
			$scope.isXeroSpinningWheelActive = true;

			if ($rootScope.accountsList) {
				delete $rootScope.accountsList;
			}

			saveXeroIntegration(params);
		}

		function getIntegrationStatus() {
			integrationsDataService
				.getIntegrationOrganization()
				.subscribe(
					data => successGetIntegrationStatus(data),
					error => messageService.showDefaultErrorMessage(error)
				);
		}

		function successGetIntegrationStatus(data) {
			if (data.integration && data.integration === 'XERO') {
				$scope.xeroOrganization = data.companyName;
			} else if (data.integration && data.integration === 'QUICKBOOKS') {
				$scope.quickbooksOrganization = data.companyName;
			} else {
				console.log('NO_INTEGRATION');
			}
			if (data.shootproofCompanyName) {
				$scope.shootproofCompanyName = data.shootproofCompanyName;
			}
		}

		$scope.initXeroIntegration = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isXeroSpinningWheelActive = true;

			integrationsDataService
				.initXeroIntegration()
				.finally(() => {
					$scope.isXeroSpinningWheelActive = false;
					$scope.lockIntegrationButtons = false;
				})
				.subscribe(
					data => doRedirect(data.value),
					result => errorConnectToXero(result.data)
				);
		};
		function errorConnectToXero(data) {
			if (
				data.errorMessage ===
				'You already have integration with accounting service'
			) {
				messageService.showToaster('e_13', 'xero');
			}
		}

		function showChooseAccountModal(accountsList) {
			$rootScope.accountsList = angular.copy(accountsList);
			$('#integrateWithXeroModal').modal('show');
		}

		$scope.editXeroIntegrationSettings = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isXeroSpinningWheelActive = true;

			integrationsDataService
				.editXeroSettings()
				.finally(() => {
					$scope.isXeroSpinningWheelActive = false;
					$scope.lockIntegrationButtons = false;
				})
				.subscribe(
					data => showChooseAccountModal(data),
					error => editXeroSettingsErrorCallback(error)
				);
		};

		$scope.disconnectXero = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isXeroDisconnectSpinningWheelActive = true;

			integrationsDataService
				.disconnectXero()
				.finally(() => {
					$scope.lockIntegrationButtons = false;
					$scope.isXeroDisconnectSpinningWheelActive = false;
				})
				.subscribe(
					data => successDisconnectXero(),
					error => messageService.showDefaultErrorMessage(error)
				);
		};

		function successDisconnectXero() {
			$scope.xeroOrganization = null;
			messageService.showToaster('s_2', 'xero');
		}

		function saveXeroIntegration(params) {
			integrationsDataService
				.sendXeroToken(params)
				.finally(() => {
					$scope.isXeroSpinningWheelActive = false;
					$scope.lockIntegrationButtons = false;
				})
				.subscribe(
					data => showChooseAccountModal(data),
					error => messageService.showDefaultErrorMessage(error)
				);
		}

		function editXeroSettingsErrorCallback({ data, status }) {
			const errorMessage = data ? data.errorMessage : null;

			let errorCode, errorPlace;

			if (errorMessage && status >= 400 && status < 500) {
				if (
					errorMessage.includes(
						'Xero access token expired, reconnect Xero please'
					) ||
					errorMessage.includes(
						'Bummer! Xero access token not authorized or revoked, reconnect Xero please'
					) ||
					errorMessage.includes(
						'Bummer! Xero access token revoked, reconnect Xero please'
					)
				) {
					errorCode = 'e_14';
					errorPlace = 'xero';
				} else if (
					errorMessage.includes("You don't have an active Xero subscription")
				) {
					errorCode = 'e_15';
					errorPlace = 'xero';
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}

			messageService.showToaster(errorCode, errorPlace);
		}

		// ShootProof
		$scope.initShootproofIntegration = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isShootProofSpinningWheelActive = true;

			shootProofDataService
				.initShootProofIntegrationV1()
				.finally(() => {
					$scope.isShootProofSpinningWheelActive = false;
					$scope.lockIntegrationButtons = false;
				})
				.subscribe(
					data => doRedirect(data.data.url),
					error => messageService.showDefaultErrorMessage(error)
				);
		};

		function handleShootproofToken(params) {
			$scope.isShootProofSpinningWheelActive = true;

			if (!params.error) {
				saveShootProofIntegration(params);
			} else {
				const path = $location.path();
				const pathWithoutShootProof = path.replace('/shootproof', '');
				$location.url(pathWithoutShootProof);
			}
		}

		function saveShootProofIntegration(params) {
			shootProofDataService.getExistingShootProofSettingsV1().subscribe(
				result => {
					$scope.shootProofIntroduction =
						result.data !== null ? result.data.clientPortalText : '';
					$scope.shootProofCode = params.code;
					messageService.showToaster('s_6', 'shootProof');
					$('#integrateWithShootProofModal').modal('show');
				},
				error => messageService.showDefaultErrorMessage(error)
			);
		}

		$scope.editShootproofIntegrationSettings = () => {
			shootProofDataService.getExistingShootProofSettingsV1().subscribe(
				result => {
					$scope.shootProofCode = null;
					$scope.shootProofIntroduction = result.data.clientPortalText || '';
					$('#integrateWithShootProofModal').modal('show');
				},
				error => messageService.showDefaultErrorMessage(error)
			);
		};

		$scope.disconnectShootproof = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isShootProofSpinningWheelActive = true;

			shootProofDataService
				.disconnectShootProofV1()
				.finally(() => {
					$scope.lockIntegrationButtons = false;
					$scope.isShootProofSpinningWheelActive = false;
				})
				.subscribe(
					() => successDisconnectShootProof(),
					error => messageService.showDefaultErrorMessage(error)
				);
		};

		function successDisconnectShootProof() {
			$scope.shootproofCompanyName = null;
			messageService.showToaster('s_2', 'shootProof');
		}

		// QUICKBOOKS
		function handleQuickbooksToken(params) {
			$scope.isQbSpinningWheelActive = true;
			if ($rootScope.accountsQB) {
				delete $rootScope.accountsQB;
			}
			saveQuickbooksIntegration(params);
		}

		$scope.initQuickbooksIntegration = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isQbSpinningWheelActive = true;

			integrationsDataService
				.initQuickbooksIntegration()
				.finally(() => {
					$scope.isQbSpinningWheelActive = false;
					$scope.lockIntegrationButtons = false;
				})
				.subscribe(
					data => doRedirect(data.value),
					error => errorConnectToToQuickbooks(error)
				);
		};
		function errorConnectToToQuickbooks({ data, status }) {
			const errorMessage = data.errorMessage;
			let errorCode, errorPlace, value;
			if (errorMessage && status >= 400 && status < 500) {
				switch (errorMessage) {
					case 'You already have integration with accounting service':
						errorCode = 'e_5';
						errorPlace = 'qb';
						break;
					case 'Sorry, your QuickBooks company should have at least one Sales account':
						errorCode = 'e_2';
						errorPlace = 'qb';
						break;
					default:
						errorCode = 'e_2';
						errorPlace = 'general';
						value = errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		function showQuickBooksModal(accountsQB) {
			$rootScope.accountsQB = angular.copy(accountsQB);
			$('#integrateWithQuickBooks').modal('show');
		}

		$scope.editQuickBooksIntegrationSettings = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isQbSpinningWheelActive = true;

			integrationsDataService
				.editQuickBooksSettings()
				.finally(() => {
					$scope.isQbSpinningWheelActive = false;
					$scope.lockIntegrationButtons = false;
				})
				.subscribe(
					data => showQuickBooksModal(data),
					error => messageService.showDefaultErrorMessage(error)
				);
		};

		function saveQuickbooksIntegration(params) {
			integrationsDataService
				.sendQuickbooksToken(params)
				.finally(() => {
					$scope.isQbSpinningWheelActive = false;
					$scope.lockIntegrationButtons = false;
				})
				.subscribe(data => showQuickBooksModal(data), err => errorSend(err));
		}

		function errorSend(err) {
			const data = err.data || null;
			if (!data) {
				return;
			}
			if (data.errorMessage.includes('companies are not supported yet')) {
				messageService.showToaster('e_8', 'qb');
			} else if (
				data.errorMessage ===
				'Sorry, your QuickBooks company should have at least one Sales account'
			) {
				messageService.showToaster('e_2', 'qb');
			} else if (
				data.errorMessage ===
				'Sorry, your QuickBooks company should have at least one Tax Code with sales tax rates'
			) {
				messageService.showToaster('e_21', 'qb');
			}
		}

		$scope.disconnectQuickbooks = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isQbDisconnectSpinningWheelActive = true;

			integrationsDataService
				.disconnectQuickbooks()
				.finally(() => {
					$scope.lockIntegrationButtons = false;
					$scope.isQbDisconnectSpinningWheelActive = false;
				})
				.subscribe(
					data => successDisconnectQuickbooks(),
					error => messageService.showDefaultErrorMessage(error)
				);
		};

		function successDisconnectQuickbooks() {
			$scope.quickbooksOrganization = null;
			messageService.showToaster('s_1', 'qb');
		}

		// Fundy

		$scope.connectToFundy = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isFundySpinningWheelActive = true;

			integrationsDataService
				.updateFundyIntegrationState(true)
				.finally(() => {
					$scope.lockIntegrationButtons = false;
					$scope.isFundySpinningWheelActive = false;
				})
				.subscribe(
					() => {
						messageService.showToaster('s_0', 'fundy');
						$scope.connectedToFundy = true;
					},
					error => {
						messageService.showDefaultErrorMessage(error);
					}
				);
		};

		$scope.disconnectFundy = () => {
			$scope.lockIntegrationButtons = true;
			$scope.isFundyDisconnectSpinningWheelActive = true;

			integrationsDataService
				.updateFundyIntegrationState(false)
				.finally(() => {
					$scope.lockIntegrationButtons = false;
					$scope.isFundyDisconnectSpinningWheelActive = false;
				})
				.subscribe(
					() => {
						messageService.showToaster('s_1', 'fundy');
						$scope.connectedToFundy = false;
					},
					error => {
						messageService.showDefaultErrorMessage(error);
					}
				);
		};

		// Helper functions

		function doRedirect(url) {
			$scope.lockIntegrationButtons = true;
			window.location.assign(url);
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/integrationsController.js